// extracted by mini-css-extract-plugin
export default {"outer":"EditHolidayComponent_outer__EOF79","mobileLineBreak":"EditHolidayComponent_mobileLineBreak__SI8RS","mobileSpace":"EditHolidayComponent_mobileSpace__xBRGI"};